module.exports = __webpack_public_path__ + "img/angele_20s_decembre_2021.c2ee8b20.jpg";